import React from 'react'
import { OfferPageState, INITIAL_OFFER_PAGE_STATE } from './offerPageStateReducer'

const OfferPageStateContext = React.createContext<OfferPageState>(INITIAL_OFFER_PAGE_STATE)

export default OfferPageStateContext
